<template>
  <b-modal id="mass-deadlines-modal" :modal-class="`adp-modal`" :body-class="`adp-modal-body`"
           :header-class="`adp-modal-header`" :footer-class="`adp-modal-footer d-flex justify-content-center`"
           @show="onShow" @hide="$emit('closeDeadlineModal', activity.activityId)" :ref="`mass-deadline-${activityIndex}`">
    <template #modal-title>
      <div class="d-flex">
        <span class="modal-title adp-h2 adp-h2__modal">{{ $t('voc.create_deadline') }}</span>
      </div>
    </template>
    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
    </template>
    <template>
      <div class="adp-p adp-p__grey" style="margin:-16px 0 35px 0;">{{ activity.name }}</div>
      <div class="adp-modal-row d-flex flex-column">
        <label class="adp-p adp-p__grey">
          {{ modalForOneEmployee ? $t('catalog.mass_deadline_for_one') : $t('catalog.mass_deadline_for_all') }}
        </label>
        <date-picker v-model="commonDeadline"
                     @change="changeDeadlineForAllEmployees($event)" :clearable="false"
                     :disabled-date="disabledRange" :lang="lang[$i18n.locale]"/>
        <span class="adp-p adp-p__grey" style="margin:28px 0 18px 0;" v-if="!modalForOneEmployee">
          {{ $t('catalog.mass_deadline_for_every') }}
        </span>
        <div v-for="(employee, i) in employees"
             :key="i" v-if="!modalForOneEmployee">
          <div class="d-flex align-content-center" style="margin-top: 9px">
            <div style="width: 70%">{{ employee.fullname }}</div>
            <date-picker v-model="dates[employee.pernumber]" class="mx-datepicker__mass-deadlines"
                         @change="changeEmployeeDeadline($event, employee)" :clearable="false"
                         :disabled-date="disabledRange" :lang="lang[$i18n.locale]"/>
          </div>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <p class="mt-3 animate-flicker" v-if="disabledForSkip">Загрузка сотрудников, пожалуйста подождите...</p>
      <button class="btn adp-btn adp-btn__dark-grey adp-btn__large"
              :class="{'disabled': disabledForSkip}"
              :disabled="disabledForSkip"
              @click="skip()">
        {{ $t('voc.skip') }}
      </button>
      <button class="btn adp-btn adp-btn__large"
              :class="{'disabled': disabled || disabledForSkip}"
              :disabled="disabled || disabledForSkip"
              @click="save()">
        {{ $t('voc.save') }}
      </button>
    </template>
    <already-exist-event-alert-modal :events="alreadyExistsEvents"/>
  </b-modal>
</template>

<script>
import MyDatePicker from "../MyDatePicker";
import api from "../../api";
import Datepicker from "vue2-datepicker";
import AlreadyExistEventAlertModal from "./AlreadyExistEventAlertModal";

export default {
  name: "MassDeadlinesModal",
  components: {
    'already-exist-event-alert-modal': AlreadyExistEventAlertModal,
    'my-date-picker': MyDatePicker,
    'date-picker': Datepicker,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
    activityIndex: {
      type: Number,
      required: true,
    },
    employeePernumbers: {
      type: [Array, Set],
    }
  },
  data: function () {
    return {
      lang: {
        ru: {
          days: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
          months: ['Янв', 'Фев', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
          placeholder: {
            date: 'Выберите дату',
            dateRange: 'Выберите диапазон дат'
          },
          formatLocale: {
            firstDayOfWeek: 1,
            months: ['Янв', 'Фев', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
            monthsShort: ['Янв', 'Фев', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
          },
          monthBeforeYear: false,
        },
        en: {
          days: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
          months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          placeholder: {
            date: 'Choose date',
            dateRange: 'Choose daterange'
          },
          formatLocale: {
            firstDayOfWeek: 1,
            months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          },
          monthBeforeYear: false,
        },
      },
      disabled: true,
      disabledForSkip: true,
      commonDeadline: null,
      dates: {},
      employees: [],
      employeesDeadlines: new Map(),
      alreadyExistsEvents: []
    }
  },
  computed: {
    disabledBefore() {
      if (this.activity.start_at) {
        return new Date(this.activity.start_at);
      }
      return null;
    },
    disabledAfter() {
      if (this.activity.end_at) {
        return new Date(this.activity.end_at);
      }
      return null;
    },
    modalForOneEmployee() {
      return (this.$route.query.pernumbers && this.$route.query.pernumbers.split(',').length === 1)
        || (this.employeePernumbers && this.employeePernumbers.length === 1)
    }
  },
  methods: {
    async onShow() {
      this.disabledForSkip = true;
      await this.getEmployees().then(() => this.disabledForSkip = false);
    },
    changeDeadlineForAllEmployees(deadline) {
      if (deadline) {
        this.commonDeadline = deadline;

        if (this.$route.query.pernumbers && this.$route.query.pernumbers.length) {
          this.$route.query.pernumbers.split(',').forEach(pernumber => {
            this.employeesDeadlines.set(Number(pernumber), deadline);
            this.dates[pernumber] = deadline;
          })
        }

        if (this.employeePernumbers && this.employeePernumbers.length) {
          this.employeePernumbers.forEach(pernumber => {
            this.employeesDeadlines.set(Number(pernumber), deadline);
            this.dates[pernumber] = deadline;
          })
        }
      }

      if (this.employeesDeadlines.size === this.employees.length) this.disabled = false;
    },
    changeEmployeeDeadline(deadline, employee) {
      this.employeesDeadlines.set(employee.pernumber, deadline);

      this.commonDeadline = null;
      this.dates = {};
      [...this.employeesDeadlines].map(item => this.dates[item[0]] = item[1]);

      if (this.employeesDeadlines.size === this.employees.length) this.disabled = false;
    },
    async save() {
      return this.assignActivity();
    },
    async skip() {
      const deadline = this.activity.end_at ? new Date(this.activity.end_at).toLocaleString() : null;
      return this.assignActivity(deadline);
    },
    async getEmployees() {
      this.disabled = true;
      await axios.get('/search?withFired=1')
        .then((resp) => {
          const hrsEmployees = resp.data;
          if (this.$route.query.pernumbers && this.$route.query.pernumbers.length) {
            this.employees = hrsEmployees.filter(e => this.$route.query.pernumbers.includes(e.pernumber))
          }
          if (this.employeePernumbers && this.employeePernumbers.length) {
            this.employees = hrsEmployees.filter(e => this.employeePernumbers.includes(e.pernumber))
          }
        })
        .then(() => this.disabled = false)
        .catch((err) => {
          console.log(err);
        });
    },
    async assignActivity(activityDeadline = null) {
      this.alreadyExistsEvents = [];
      for (let employee of this.employees) {
        const newDeadline = new Date(this.employeesDeadlines.get(employee.pernumber)).toLocaleString()
        let data = {
          activityId: this.activity.activityId,
          activityType: this.activity.activityType,
          role: window.IDP.role,
          participant_pernumber: employee.pernumber,
          deadline: activityDeadline ? activityDeadline : newDeadline,
        };

        const resp = await api.assignCatalogEvent(data);
        if (resp.data.success === false) {
          this.alreadyExistsEvents.push({employee: employee.pernumber, activity: this.activity});
        }
      }

      if (this.alreadyExistsEvents.length) {
        await this.$bvModal.show('already-exist-event-alert-modal');
        return;
      }

      if (this.activityIndex === 0) {
        this.$bvModal.hide('mass-deadlines-modal');
        if (this.$route.name === 'catalog') {
          return this.$emit('assignments-list-open');
        }
        if (this.$route.query.pernumbers && this.$route.query.pernumbers.length) {
          await this.$router.push({name: `${this.$role}-employee`, params: {pernumber: this.$route.query.pernumbers.split(',')[0]}});
          window.location.reload();
        }
        if (this.employeePernumbers && this.employeePernumbers.length) {
          this.$bvModal.hide('mass-assignments-modal');
          window.location.reload();
        }
      } else {
        this.$refs[`mass-deadline-${this.activityIndex}`].isHidden = true;
        this.$refs[`mass-deadline-${this.activityIndex}`].isClosing = true;
      }
    },
    disabledRange (date) {
      if (this.disabledAfter && this.disabledBefore) {
        return date < this.disabledBefore || date > this.disabledAfter;
      }
      if (this.disabledBefore) {
        return date < this.disabledBefore;
      }
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
  },
}
</script>
